import { render, staticRenderFns } from "./NodaiOkhotskView.vue?vue&type=template&id=5ea3c8e9&scoped=true&"
import script from "./NodaiOkhotskView.vue?vue&type=script&lang=js&"
export * from "./NodaiOkhotskView.vue?vue&type=script&lang=js&"
import style0 from "./NodaiOkhotskView.vue?vue&type=style&index=0&id=5ea3c8e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea3c8e9",
  null
  
)

export default component.exports